export const DocumentSummary = ({ label, value, detail, color, selected, onClick, testId, valueTestId, title }) => {
  const Tag = onClick ? 'button' : 'div';
  return <Tag {...(onClick ? { type: 'button', onClick, 'aria-pressed': !!selected } : {})}
    className={`document-summary-item ${selected ? 'is-selected' : ''}`} data-testid={testId} title={title}
    style={{ '--summary-color': color || '#27272A' }}>
    <span className="document-summary-label" data-testid={`${testId}-label`}>{label}</span>
    <span className="document-summary-value" data-testid={valueTestId || `${testId}-value`}>{value}</span>
    {detail && <span className="document-summary-detail" data-testid={`${testId}-detail`}>{detail}</span>}
  </Tag>;
};